export default __webpack_public_path__ + "static/media/AMPLIUS-CUISINE.f42b0887.png";